// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__VGVUt","title":"AfterBackImages_title__3088l","images":"AfterBackImages_images__SkUSL"};